module.exports = __webpack_public_path__ + "img/bg3.fd028084.png";